import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";

import * as actions from "../../store/actions/index";
import { withRouter } from "../../shared/utility";
import EmptyModal from "../../components/modals/EmptyModal";
import SlideOver from "../../components/slideOver/SlideOver";
import SunOrderForm from "../../components/forms/sunOrders/SunOrderForm";
import { useSunOrderFormViewModel } from "../../viewmodels/sunOrders/useSunOrderFormViewModel";
import ShipmentReportButton from "../../components/shippingReports/ShipmentReportButton";

function SunOrderDetails(props: any) {
  const { logout, addSnackbar } = props;
  const { orderId } = useParams();
  const {
    customers,
    sunCustomers,
    employeeOptions,
    order,
    loading,
    emptyModal,
    setEmptyModelOpen,
    showErrorModal,
    slideOver,
    setSlideOver,
    getCustomersForDropdown,
    getSunCustomersForDropdown,
    getEmployeesForDropdown,
    getMyProducts,
    getOrderDetails,
    updateOrderApiCall,
    onUpdateOrderItem,
    updateOrderItemUnitPrice,
    deleteOrderItemApiCall,
    addProductToOrderApiCall,
    openSunShippingLabelReview,
    openSunBolReview,
    createSunOrderInvoice,
  } = useSunOrderFormViewModel(logout, addSnackbar, orderId);

  useEffect(() => {
    const load = async () => {
      await getEmployeesForDropdown([1, 2], [1, 6]);
      await getCustomersForDropdown();
      await getSunCustomersForDropdown();
      await getOrderDetails();
    };
    load();
  }, [orderId]);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        <div className="sm:items-center">
          <div className="flex flex-col justify-between gap-3 sm:flex-row sm:items-center">
            <div className="sm:flex-auto">
              <h1 className="text-xl font-semibold leading-6 text-gray-900">
                Editing Sun Order {order ? order.po_number : null}
              </h1>
            </div>
            {order ? (
              <ShipmentReportButton
                parentType="sunOrder"
                parentId={order.id}
                logout={logout}
                addSnackbar={addSnackbar}
              />
            ) : null}
          </div>
          <div className="mt-5">
            {loading ? (
              <div className="text-sm text-gray-500">Loading...</div>
            ) : order ? (
              <SunOrderForm
                customers={customers}
                sunCustomers={sunCustomers}
                getMyProducts={getMyProducts}
                employeeOptions={employeeOptions}
                isEdit={true}
                order={order}
                loading={loading}
                setEmptyModelOpen={setEmptyModelOpen}
                showErrorModal={showErrorModal}
                updateOrderApiCall={updateOrderApiCall}
                onUpdateOrderItem={onUpdateOrderItem}
                updateOrderItemUnitPrice={updateOrderItemUnitPrice}
                deleteOrderItemApiCall={deleteOrderItemApiCall}
                addProductToOrderApiCall={addProductToOrderApiCall}
                openSunShippingLabelReview={openSunShippingLabelReview}
                openSunBolReview={openSunBolReview}
                createSunOrderInvoice={createSunOrderInvoice}
              />
            ) : null}
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        customClass={slideOver.customClass ?? "max-w-3xl"}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapDispatchToProps = (dispatch: any) => ({
  logout: () => dispatch(actions.logout()),
  addSnackbar: (snackbar: any) => dispatch(actions.addSnackbar(snackbar)),
});

export default withRouter(connect(null, mapDispatchToProps)(SunOrderDetails));
